export const COURSE_STATUS = {
	REGISTER: 0,
	CONTINUE_LEARNING: 1,
	PURCHASING: 2,
	ENROLL: 3,
	WAITING_FOR_PAYMENT: 4,
	GIFTED: 5,
} as const

export const COURSE_STATUS_LABELS = {
	[COURSE_STATUS.REGISTER]: "Đăng ký",
	[COURSE_STATUS.CONTINUE_LEARNING]: "Học tiếp",
	[COURSE_STATUS.PURCHASING]: "Đang mua",
	[COURSE_STATUS.ENROLL]: "Đăng ký",
	[COURSE_STATUS.WAITING_FOR_PAYMENT]: "Đang chờ thanh toán",
	[COURSE_STATUS.GIFTED]: "Học tiếp",
} as const

export type CourseStatus = (typeof COURSE_STATUS)[keyof typeof COURSE_STATUS]
